














































































import { Component, Prop, Vue } from 'vue-property-decorator';

import CloseIcon from '@/components/icons/Close.vue';

import eventBus from '@/utils/eventBus';

import CoinIcon from '@/components/icons/WidgetCoin.vue';
import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import CycleDays from '@/componentsV2/molecules/CycleDays/CycleDays.vue';
import { EBillingStatusTypes } from '@/store/modules/businessTypes';
import BillingService from '@/api/BillingService';
import FeaturesDeactivation from './FeaturesDeactivation.vue';
import DateUtils from '@/utils/DateUtils';
import { features } from '@/components/organisms/ActivateFeatureWidgetModal/featuresHelper';
import flagKeys from '@/constants/flagKeys';
import segmentIo from '@/utils/segment.io';
import { getNeedsOnboardingCall } from '@/utils/onboardingCall';
import { getBillingOnboardingCallPending } from '@/utils/billing';

@Component({
  components: {
    CloseIcon,
    CoinIcon,
    Typography,
    FilledButton,
    CycleDays,
    FeaturesDeactivation
  }
})
export default class CoinNetworkDeactivationModal extends Vue {
  @Prop() subscription!: any;
  @Prop() origin!: string;
  @Prop() features!: any;

  loading = false;

  service = new BillingService();

  get campaigns() {
    let availableFeatures: any = this.features;

    const featuresAvailables = Object.keys(availableFeatures);

    return features
      .filter((feature: any) => featuresAvailables.includes(feature.value))
      .map((feature: any) => {
        return {
          label: feature.title,
          icon: feature.icon
        };
      });
  }

  get needsOnboardingCall() {
    return getNeedsOnboardingCall();
  }

  get business() {
    return this.$store.getters['business/getBusinessInfo'].business;
  }

  get tPrefix() {
    return 'modals.billing.deactivation';
  }

  get showDisclaimer() {
    return !(this.delayedPeriod && this.campaigns.length === 0);
  }

  get delayedPeriod() {
    return (
      (this.billingModuleV3 && this.subscription.eligibleForDelayPeriod) ||
      getBillingOnboardingCallPending()
    );
  }

  get insideTheBillingCycle() {
    if (this.delayedPeriod) return false;

    const now = DateUtils.formattedDate({
      date: new Date(),
      applyTimezone: true
    });
    const Difference_In_Days = DateUtils.getDifferenceDays(now, this.endDate);

    return Difference_In_Days >= 1 && Difference_In_Days <= 7;
  }

  get startDate() {
    return this.subscription.billingCycle.startAt;
  }

  get endDate() {
    return this.subscription.billingCycle.endAt;
  }

  get tDescription() {
    const prefix = this.insideTheBillingCycle ? 'less' : 'in';

    const prefixDelayed =
      this.campaigns.length > 0 ? 'with-campaign' : 'without-campaign';

    let value = this.delayedPeriod
      ? `${prefixDelayed}-delayed`
      : `${prefix}-7-days`;

    if (this.needsOnboardingCall) value = `needs-onboarding-call`;

    return `${this.tPrefix}.description.${value}`;
  }

  get tTitle() {
    const value = this.delayedPeriod ? 'delayed' : 'default';
    return `${this.tPrefix}.title.${value}`;
  }

  get businessInfo() {
    return this.$store.getters['business/getBusinessInfo'].business;
  }

  get flags() {
    return this.$store.getters['flags/getFlags'] || [];
  }

  get billingModuleV3() {
    return this.flags.includes(flagKeys.billingModuleV3);
  }

  getDate(date: string) {
    return DateUtils.formattedDate({
      date: date
    });
  }

  async onSecondaryClick() {
    this.loading = true;
    try {
      const status = this.insideTheBillingCycle
        ? EBillingStatusTypes.TO_BE_CANCELED
        : EBillingStatusTypes.UNSUBSCRIBED;

      const { data } = await this.service.deactivateSubscription();
      if (data) {
        this.$store.dispatch('business/SET_BUSINESS_INFO', {
          ...this.businessInfo,
          subscriptionStatus: status
        });

        segmentIo.track('Clicked Billing Deactivation Finish', {
          Origin: this.origin
        });

        eventBus.$emit('reloadCoinNetworkOverview');
        eventBus.$emit('reloadCoinNetworkActivities', { clearList: true });
        this.onClose();
      }
    } finally {
      this.loading = false;
    }
  }

  onPrimaryClick() {
    segmentIo.track('Clicked Billing Deactivation Close', {
      Origin: this.origin
    });
    this.onClose();
  }

  onClose() {
    eventBus.$emit('closeModal');
  }

  created() {
    segmentIo.modal('Billing Deactivation', {
      Origin: this.origin,
      'In The Cycle': !!this.insideTheBillingCycle,
      'Delayed Period': !!this.delayedPeriod
    });
  }
}
